const apiBase = "";
const tunnelApiBase = "https://inex-abo-api-33dvsn7xmq-ew.a.run.app";

export { apiBase, tunnelApiBase };
